import React from 'react'
import styles from './Sidebar.module.scss'

const Sidebar = () => {
  return <div className={styles.root}>
    SIDEBAR
  </div>
}

export default Sidebar